import React from "react";
import CancelIcon from '@mui/icons-material/Cancel';
import styled from "@emotion/styled";
import SweepPerformances from "../../Windows/SweepPerformances";

const SweepPerformanceModal = ({ handleCloseModal, origin }) => {
  return (
    <ModalShell>
      <ModalHeader>
        <HeaderCopy>
          <Eyebrow>Reporting</Eyebrow>
          <Title>Monthly Sweep Summaries</Title>
          <Subtitle>
            Review monthly public-record sweep health, source connectivity, and lead outcomes across the portfolio.
          </Subtitle>
        </HeaderCopy>
        <CloseButton type="button" aria-label="Close Monthly Sweep Summaries" onClick={() => handleCloseModal()}>
          <CancelIcon />
        </CloseButton>
      </ModalHeader>

      <ModalBody>
        <SweepPerformances origin={origin} />
      </ModalBody>
    </ModalShell>
  )
}

const ModalShell = styled.section(({ theme }) => `
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: ${theme.palette.common.pageBackground};
`)

const ModalHeader = styled.header(({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 1.05rem 1.25rem 1rem 1.45rem;
  border-bottom: 0.1rem solid ${theme.palette.common.grayBorder};
  background: ${theme.palette.common.white};
`)

const HeaderCopy = styled.div`
  min-width: 0;
`

const Eyebrow = styled.div(({ theme }) => `
  color: ${theme.palette.primary.dark};
  font-size: 0.76rem;
  font-weight: 900;
  letter-spacing: 0.08rem;
  line-height: 1.2;
  text-transform: uppercase;
`)

const Title = styled.h2(({ theme }) => `
  margin: 0.12rem 0 0;
  color: ${theme.palette.common.black};
  font-size: 1.55rem;
  font-weight: 900;
  line-height: 1.16;
`)

const Subtitle = styled.p(({ theme }) => `
  max-width: 52rem;
  margin: 0.25rem 0 0;
  color: ${theme.palette.common.grayText};
  font-size: 0.92rem;
  font-weight: 650;
  line-height: 1.35;
`)

const CloseButton = styled.button(({ theme }) => `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 2.5rem;
  height: 2.5rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 50%;
  background: ${theme.palette.common.white};
  color: ${theme.palette.common.grayText};
  box-shadow: 0 0.35rem 0.9rem rgba(15, 23, 42, 0.08);
  cursor: pointer;
  transition: border-color 140ms ease, color 140ms ease, box-shadow 140ms ease, transform 140ms ease;

  svg {
    width: 1.3rem;
    height: 1.3rem;
  }

  &:hover {
    border-color: ${theme.palette.primary.main};
    color: ${theme.palette.primary.dark};
    box-shadow: 0 0.5rem 1.1rem rgba(15, 23, 42, 0.12);
    transform: translateY(-0.05rem);
  }
`)

const ModalBody = styled.div`
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  padding: 1rem;
`

export default SweepPerformanceModal
